import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { MasterService } from "../../modules/master/services";
import { HttpclientService } from "./httpclient.service";

@Injectable()
export class SchoolService {
	constructor(private httpclientService: HttpclientService, private masterService: MasterService) {}
	loadSchoolList(applicationItemID) {
		//Get all schools (like for dashboard)
		if (applicationItemID == "All" || applicationItemID.includes("0000-")) {
			applicationItemID = "";
		}
		//Not a GUID
		else if (applicationItemID.length != 36) {
			//Check if no GUID is found by master service
			try {
				var applicationItem = this.masterService.getCurrentApplicationItem();

				applicationItemID = applicationItem.ApplicationItemID;

				if (applicationItemID == undefined || applicationItemID.length != 36) {
					applicationItemID = "";
				}
			} catch (e) {
				e.toString();
				applicationItemID = "";
			}
		}
		//Else use the GUID that was passed

		var postResult$ = new Subject();
		var url = "Security/SchoolGetList?ApplicationItemID=" + applicationItemID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadSchoolListWithOptions(applicationItemID, TableTypeID) {
		//Get all schools (like for dashboard)
		if (applicationItemID == "All" || applicationItemID.includes("0000-")) {
			applicationItemID = "";
		}
		//Not a GUID
		else if (applicationItemID.length != 36) {
			//Check if no GUID is found by master service
			try {
				var applicationItem = this.masterService.getCurrentApplicationItem();

				applicationItemID = applicationItem.ApplicationItemID;

				if (applicationItemID == undefined || applicationItemID.length != 36) {
					applicationItemID = "";
				}
			} catch (e) {
				e.toString();
				applicationItemID = "";
			}
		}
		//Else use the GUID that was passed

		var postResult$ = new Subject();
		var url = "Security/SchoolGetListWithOptions?ApplicationItemID=" + applicationItemID + "&TableTypeID=" + TableTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetSchoolsForUserReport(ReportID) {
		var postResult$ = new Subject();
		var url = "Security/GetSchoolsForUserReport?ReportID=" + ReportID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
